import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/theme/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/common/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import LoginPage from "@/pages/LoginPage";
import HomePage from "@/pages/HomePage";
import WalletPage from "@/pages/transactions/WalletPage";
import InvoicesPage from "@/pages/transactions/InvoicesPage";
import CreditPage from "@/pages/transactions/CreditPage";
import CustomerTransactionsPage from "@/pages/transactions/CustomerTransactionsPage";
import GiftCardsDiscountPage from "@/pages/discount-mapping/GiftCardsDiscountPage";
import BBPSDiscountPage from "@/pages/discount-mapping/BBPSDiscountPage";
import SharedSubscriptionsDiscountPage from "@/pages/discount-mapping/SharedSubscriptionsDiscountPage";
import GiftCardsOrdersPage from "@/pages/order-history/GiftCardsOrdersPage";
import BBPSOrdersPage from "@/pages/order-history/BBPSOrdersPage";
import SharedSubscriptionsOrdersPage from "@/pages/order-history/SharedSubscriptionsOrdersPage";
import GiftCardsStocksPage from "@/pages/stocks/GiftCardsStocksPage";
import GeneralSettingsPage from "@/pages/settings/GeneralSettingsPage";
import DeveloperSettingsPage from "@/pages/settings/DeveloperSettingsPage";
import SDKConfigurationPage from "@/pages/settings/SDKConfigurationPage";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected dashboard */}
            <Route
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />

              <Route path="transactions">
                <Route index element={<Navigate to="wallet" replace />} />
                <Route path="wallet" element={<WalletPage />} />
                <Route path="invoices" element={<InvoicesPage />} />
                <Route path="credit" element={<CreditPage />} />
                <Route path="customers" element={<CustomerTransactionsPage />} />
              </Route>

              <Route path="discount-mapping">
                <Route index element={<Navigate to="gift-cards" replace />} />
                <Route path="gift-cards" element={<GiftCardsDiscountPage />} />
                <Route path="bbps" element={<BBPSDiscountPage />} />
                <Route path="shared-subscriptions" element={<SharedSubscriptionsDiscountPage />} />
              </Route>

              <Route path="order-history">
                <Route index element={<Navigate to="gift-cards" replace />} />
                <Route path="gift-cards" element={<GiftCardsOrdersPage />} />
                <Route path="bbps" element={<BBPSOrdersPage />} />
                <Route path="shared-subscriptions" element={<SharedSubscriptionsOrdersPage />} />
              </Route>

              <Route path="stocks">
                <Route index element={<Navigate to="gift-cards" replace />} />
                <Route path="gift-cards" element={<GiftCardsStocksPage />} />
              </Route>

              <Route path="settings">
                <Route index element={<Navigate to="general" replace />} />
                <Route path="general" element={<GeneralSettingsPage />} />
                <Route path="developer" element={<DeveloperSettingsPage />} />
                <Route path="sdk" element={<SDKConfigurationPage />} />
              </Route>
            </Route>

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
